import React from "react";
import { FooterWrapper } from "./Styled";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
	Box,
	LazyImage,
	SpanStyled,
} from "../../ui/Elements";
import { ContactFacebook, ContactInstagram, ContactSnapchat, ContactX, FooterFacebook, FooterInstagram, FooterLogoAr, FooterLogoEn, FooterSnapchat, FooterX, MinistryLogo1, MinistryLogo2 } from "../../ui/AllImages";
import { Link } from "react-router-dom";



const Footer = () => {
	const {
		t,
		i18n: { language },
	} = useTranslation();
	const date_year = new Date();
	const FowlUrl = () => {
		const whatsappURL = "https://fowl.sa/home";
		window.open(whatsappURL, "_blank");
	};
	const FowlWeb = () => {
		window.open("https://websites.fowl.sa/", "_blank");
	};
	const socialIcon = [
			{
				img: <FooterFacebook/>,
				link: 'https://www.facebook.com',
			},
			{
				img: <FooterX />,
				link: 'https://x.com/',
			},
			{
				img: <FooterInstagram />,
				link: 'https://www.instagram.com/',
			},
			{
				img: <FooterSnapchat />,
				link: 'https://snapchat.com/',
			},
			// {
			//     img: <Tiktok />,
			//     link: 'https://www.tiktok.com/@user3666835522780?_t=ZS-8ztPKClli3p&_r=1',
			// },
			
			// {
			//     img: <ContactLinkedin />,
			//     link: 'https://www.linkedin.com/',
			// },
		]
	return (
		<FooterWrapper className="container-fluid footerWrapper" lang={language}>
			<Box className="footerCrWrapper">
				<Container className="footerContain2">
					<Row className="footer-row align-items-center justify-content-center justify-content-md-between">
						<Box className="footerLogo">
							{language === "ar" ? (
								<FooterLogoAr />
							) : (
								<FooterLogoEn />
							)}
						</Box>
						<Box className="text-center copyright">
							<SpanStyled
								className="footer-op"
								size="16px"
								color="var(--bg2)"
								transform="capitalize"
							>
								{/* {t("Copyright")}  */}
								&copy; {date_year.getFullYear()}
								<SpanStyled
									className="footer-op footer-op-company"
									size="16px"
									color="var(--white)"
									family="var(--bold)"
								>
									&nbsp;{t("myOffice")}.
								</SpanStyled>
							</SpanStyled>
							<SpanStyled
								className="footer-op footer-op-allRights"
								size="16px"
								color="var(--bg2)"
								transform="capitalize"
							>
								&nbsp;{t("AllRightReserved2")}
							</SpanStyled>
						</Box>
						<Box className='Social-links'>
							{
								socialIcon.map((list, key) => (
									<a href={list.link} target="_blank" key={key} className='footer-social-links'>
										{list.img}
									</a>
								))
							}
						</Box>

					</Row>
				</Container>
			</Box>
		</FooterWrapper>
	);
};

export default Footer;
